import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Quote, Star } from "lucide-react";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/testimonials"); setItems(data); })(); }, []);
  return (
    <main className="pt-28 pb-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="ali-chip">Student Stories</div>
        <h1 className="mt-4 font-satoshi font-black text-4xl sm:text-5xl text-[#0A192F] tracking-tight">Real people. Real wins.</h1>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map(t => (
            <div key={t.id} className="ali-card p-6" data-testid={`testi-${t.id}`}>
              <div className="flex items-center gap-3">
                <img src={t.avatar} alt="" className="w-12 h-12 rounded-full bg-orange-50" />
                <div>
                  <p className="font-satoshi font-bold text-[#0A192F]">{t.name}</p>
                  <p className="text-xs text-[#FF6B35] font-poppins font-semibold">{t.role}</p>
                </div>
              </div>
              <Quote className="w-6 h-6 text-[#FF6B35]/40 mt-4" />
              <p className="font-inter text-slate-600 leading-relaxed">{t.quote}</p>
              <div className="mt-4 flex items-center gap-1">
                {Array.from({ length: t.rating }).map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />)}
                <span className="ml-2 text-xs text-slate-400">· {t.course}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
